module.exports = __webpack_public_path__ + "img/hardware-changes.3e96af2c.svg";